import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

interface IDeveloperHeaderPhoneProps {
  phone: string;
}

export const DeveloperHeaderPhone: React.FC<IDeveloperHeaderPhoneProps> = ({ phone }) => {
  return (
    <div className={style['phone']} data-testid="Phone">
      <UIHeading2>{phone}</UIHeading2>
    </div>
  );
};
